import React, { useMemo } from "react";
import { useTranslate } from "hooks";
import { useProjectUIActions } from "stores/project/ui/projectUIStore";
import cx from "classnames";
import { IconButton } from "components/IconButton/IconButton";
import s from "./ExpandCollapseStyles.module.scss";

export const ExpandCollapseLevels = React.memo(() => {
  const translations = useGetTranslations();
  const actions = useProjectUIActions();
  return (
    <div className="d-flex gap-2">
      <IconButton
        testId="expandAllButton"
        id={`expandAllButton`}
        icon="chevron-expand-regular"
        color="tertiary"
        iconClassName={cx("icon-16 rounded-2 p-1", s.iconButton)}
        className="border-0"
        tooltipText={translations.expandAll}
        onClick={actions.expandAll}
      />
      <IconButton
        testId="collapseAllButton"
        id={`collapseAllButton`}
        icon="chevron-collapse-regular"
        color="tertiary"
        iconClassName={cx("icon-16 rounded-2 p-1", s.iconButton)}
        className="border-0"
        tooltipText={translations.collapseAll}
        onClick={actions.collapseAll}
      />
      <IconButton
        testId="expandLevelButton"
        id={`expandLevelButton`}
        icon="chevron-down-regular"
        color="tertiary"
        iconClassName={cx("icon-16 rounded-2 p-1", s.iconButton)}
        className="border-0"
        tooltipText={translations.expandLevel}
        onClick={actions.expandLevel}
      />
      <IconButton
        testId="collapseLevelButton"
        id={`collapseLevelButton`}
        icon="chevron-up-regular"
        color="tertiary"
        iconClassName={cx("icon-16 rounded-2 p-1", s.iconButton)}
        className="border-0"
        tooltipText={translations.collapseLevel}
        onClick={actions.collapseLevel}
      />
    </div>
  );
});

const useGetTranslations = () => {
  const translate = useTranslate();
  const translations = useMemo(
    () => ({
      expandAll: translate("PROJECT_STRUCTURE_EXPAND_ALL"),
      collapseAll: translate("PROJECT_STRUCTURE_COLLAPSE_ALL"),
      expandLevel: translate("PROJECT_STRUCTURE_EXPAND_LEVEL"),
      collapseLevel: translate("PROJECT_STRUCTURE_COLLAPSE_LEVEL"),
    }),
    [translate],
  );
  return translations;
};
